import moment from 'moment'

function dateFormat(date) {
  return moment(date).format('DD MMM YYYY - hh:mm A')
}

function transformDataChart(data) {
  try {
    const myData = data?.map((value) => {
      const {
        actual_total,
        packed_last_modified_by,
        planned_last_modified_by,
        actual_last_modified_by,
        packed_total,
        planned_total,
        actual_total_accumulated,
        planned_total_accumulated,
        packed_total_accumulated,
        planned_last_modified_date,
        actual_last_modified_date,
        packed_last_modified_date,
      } = value
      const chartData: any = {
        name: '',
        plan: planned_total_accumulated,
        actual: actual_total_accumulated,
        user: {
          plan: {
            name: planned_last_modified_by?.first_name,
            profile: planned_last_modified_by?.avatar?.url_path,
          },
          actual: {
            name: actual_last_modified_by?.first_name,
            profile: actual_last_modified_by?.avatar?.url_path,
          },
          pack: {
            name: packed_last_modified_by?.first_name,
            profile: packed_last_modified_by?.avatar?.url_path,
          },
        },
        last_modified_dates: {
          plan: dateFormat(planned_last_modified_date),
          actual: dateFormat(actual_last_modified_date),
          pack: dateFormat(packed_last_modified_date),
        },
        totals: {
          plan: planned_total,
          actual: actual_total,
          pack: packed_total,
        },
      }

      if (packed_total_accumulated) chartData.pack = packed_total_accumulated

      return chartData
    })

    return myData || []
  } catch (error) {
    return []
  }
}

export default transformDataChart
